import { defaultColors } from '../../../../Common/Services/contexts/ServicesChartsDataContext';
import {
    monthsIndexesWithou0
} from '../../../../Common/Util/getMonthsByYear';
import { useSummaryChartsDataContext } from './useSummaryChartsDataContext';

const useMonthlyEvolutionServices = () => {
    const { chartData } = useSummaryChartsDataContext();

    const categories = chartData.monthlyEvolutionServices.map(
        (item) => monthsIndexesWithou0[item.description]
    );

    const subtitles = ['Atendimentos', 'Atendimentos - Ano Anterior'];

    const series = subtitles.map((item) => {
        const data = categories.map((category) => {
            const found = chartData.monthlyEvolutionServices.find(
                (counter) =>
                    monthsIndexesWithou0[counter.description] === category
            );

            let value = 0;

            switch (item) {
                case 'Atendimentos':
                    value = found ? found.totalYear : 0;
                    break;
                case 'Atendimentos - Ano Anterior':
                    value = found ? found.totalPreviousYear : 0;
                    break;
                default:
                    value = 0;
                    break;
            }

            return Number(value);
        });

        return {
            name: item,
            data,
            type: item === 'Atendimentos' ? 'bar' : 'line'
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'line',
                height: 400,
                stacked: false,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '50%',
                    endingShape: 'rounded',
                    dataLabels: {
                        position: 'top'
                    }
                }
            },
            yaxis: {
                labels: {
                    formatter: (val) => val.toLocaleString('pt-BR')
                }
            },
            stroke: {
                width: [4, 4]
            },
            xaxis: {
                categories: categories || []
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            dataLabels: {
                enabled: true,
                style: {
                    fontSize: '12px',
                    colors: ['#000']
                },
                offsetY: -20,
                enabledOnSeries: [0]
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Arial, sans-serif',
                    padding: '10px',
                    pointerEvents: 'auto',
                    zIndex: '1000'
                },
                y: {
                    formatter: (val) => (val ? val.toLocaleString('pt-BR') : '')
                }
            },
            colors: defaultColors
        }
    };

    return {
        chartConfig
    };
};

export default useMonthlyEvolutionServices;
